module.exports = __webpack_public_path__ + "static/media/covid19WashHands.17533727.png";